module.exports = __webpack_public_path__ + "img/ufa-bet-support.5591ef72.png";